document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 767) {
    new Swiper('.ingredients-mobile', {
      slidesPerView: 2,
      spaceBetween: 14,
      loop:true,
           autoplay: {
              delay: 2000,
              disableOnInteraction: false,
            },
      pagination: {
        el: '.ingredients-pagination',
        clickable: true
      }
    });
  }
});



document.addEventListener('DOMContentLoaded', function () {

  const form = document.getElementById('customConsultingForm');
  if (!form) return;

  const successMsg = document.querySelector('.custom-consulting-success');
  const button = form.querySelector('.custom-consulting-btn');
  const btnText = button.querySelector('.btn-text');

  const googleSheetURL =
    'https://script.google.com/macros/s/AKfycbw1WeGUMJbKw9GBHTDfDRtNHaeklCLj9tIPdwwk8jiFwb0tYFCS_SpQQ4MG40Qb9mLgEA/exec';

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // UI: loading state
    button.classList.add('loading');
    button.disabled = true;
    btnText.textContent = 'Submitting...';

    const formData = {
      fullName: form.querySelector('input[name="fullName"]').value,
      phone: form.querySelector('input[name="phone"]').value,
      age: form.querySelector('input[name="age"]').value,
      // gender: form.querySelector('select[name="gender"]').value,
      consultation: form.querySelector('select[name="consultation"]').value,
      email: form.querySelector('input[name="email"]').value,
      consent: document.getElementById('consultingConsent').checked ? 'Yes' : 'No'
    };

    console.log('📤 Sending to Google Sheet:', formData);

    fetch(googleSheetURL, {
      method: 'POST',
      body: JSON.stringify(formData)
    })
      .then(res => res.text())
      .then(response => {
        console.log('✅ Google Sheet Response:', response);

        button.classList.remove('loading');
        btnText.textContent = 'Submitted ✅';
        successMsg.style.display = 'block';

        form.reset();
      })
      .catch(error => {
        console.error('❌ Submission Error:', error);

        button.classList.remove('loading');
        btnText.textContent = 'Submit';
        button.disabled = false;

        alert('Something went wrong. Please try again.');
      });
  });

  const phoneInput = form.querySelector('input[name="phone"]');
  phoneInput.addEventListener('input', function () {
    this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
  });

});


